import feed_report from "./feed_report";
import manure_solid_report from "./manure_solid_report";
import mixer_efficiency_report from "./mixer_efficiency_report";
import sar_report from "./sar_report";
import septic_report from "./septic_report";
import tissue_report from "./tissue_report";
import water_report from "./water_report";
import western_tractor_report from "./western_tractor_report";
import soil_report from "./soil_report";

const types = {
  feed: feed_report,
  general: manure_solid_report,
  mixer_efficiency: mixer_efficiency_report,
  sar: sar_report,
  septic: septic_report,
  tissue: tissue_report,
  water: water_report,
  western_tractor: western_tractor_report,
  soil: soil_report,
};

export const ReportTypes = {
  get: type => types[type]
}

